import React, { useMemo, useState } from 'react';
import { useSortBy, useTable, usePagination } from 'react-table';
import axios from 'axios';
import {
	AUTHORIZED_URL_PREFIX,
    NOTIFICATION_SEVERITY_INFO,
  	NOTIFICATION_SEVERITY_SUCCESS,
	AxiosConfig,
    ADD_EDITION_CODE_URL,
	UPDATE_EDITION_CODE_STATUS
} from '../../Utils/Constants';
import t from '../../Utils/Translation';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import LykioButton from "../common/LykioButton";
import friendlyDate from '../../Utils/FriendlyDate';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import { FaInfo } from 'react-icons/fa';

const EditionCode = (props) => {
	const editionCodes = props.editionCodes;
    const [ myTableData, setmyTableData ] = useState(useMemo(() => [ ...editionCodes ], []));
    const [newEditionCode, setNewEditionCode] = useState('');
	const [editionCodeStartDate, setEditionCodeStartDate] = useState(new Date());
	const [infoNewEditionCode, setInfoNewEditionCode] = useState(false);

	//Table Design Headers/Columns
	const myTableColumns = useMemo(
		() => [
            {
				Header: t('Id'),
				accessor: (row, index) => index + 1
			},
			{
				Header: t('Name'),
				accessor: 'name'
			},
			{
				Header: t('Creation date'),
				accessor: 'creationDate',
				Cell: ({ value }) => {
					return friendlyDate(new Date(value));
				}
			},
			{
				Header: t('Status'),
				accessor: 'status',
				Cell: ({ value }) => {
					const statusLabel = value ? t('activated') : t('deactivated');
					return statusLabel;
				},
			}
		],
		[]
	);

	//Insert column with Actions buttons
	const tableHooks = (hooks) => {
		hooks.visibleColumns.push((columns) => [
			...columns,
			{
				id: 'Actions',
				Header: t('Actions'),
				Cell: ({ row }) => (
					<React.Fragment>
						{getButtons(editionCodes[row.id]._id, editionCodes[row.id].status/*, editionCodes[row.id].role.name*/)}
						{/* {userTableButtonComponent('Edit', () => editUnitHandler(units[row.id]._id))} */}
					</React.Fragment>
				)
			}
		]);
	};

	//React Table Setup
	const tableInstance = useTable(
		{ columns: myTableColumns, data: myTableData, initialState: { pageSize: myTableData.length } },
		tableHooks,
		useSortBy,
		usePagination
	);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		canPreviousPage,
		pageOptions,
		gotoPage,
		pageCount,
		setPageSize,
		state,
		prepareRow
	} = tableInstance;

	const { pageIndex, pageSize } = state;

	//LykioButton Component
	const userTableButtonComponent = (label, buttonHandler) => {
		return (<React.Fragment>
			<LykioButton variant="text" onClick={() => {
				buttonHandler();
			}}>
				{t(`${label}`)}
			</LykioButton>&nbsp;
			</React.Fragment>
		);
	};

	//Decide what buttons to show
	const getButtons = (editionCodeId, editionCodeStatus) => {
		return (
			<React.Fragment>
                {editionCodeStatus === false && 
				<React.Fragment>{userTableButtonComponent(t('Activate'), () =>
                    editionCodeModerationHandler(editionCodeId, true))}&nbsp;</React.Fragment>
				}

				{editionCodeStatus === true && 
				<React.Fragment>{userTableButtonComponent(t('Deactivate'), () =>
                 editionCodeModerationHandler(editionCodeId, false))}&nbsp;</React.Fragment>
				}
				
			</React.Fragment>)
	};

    // upload a new edition code
    const newEditionCodeUploadHandler = async () => {
        if (newEditionCode) {
            try {
                const { data } = await axios.post(
                    `${AUTHORIZED_URL_PREFIX}${ADD_EDITION_CODE_URL}`,
                    { newEditionCode, editionCodeStartDate },
                    AxiosConfig()
                );
                if (data.success === true) {
                    notify({
                        title: `${t('Your edition code was added successfully.')}`,
                        severity: NOTIFICATION_SEVERITY_SUCCESS,
                        creationDate: ''
                    });
					window.dispatchEvent(new Event('editionCodeAddedOrChanged'));
                } else {
                    notify({
                        title: `${t('This edition code already exists.')}`,
                        severity: NOTIFICATION_SEVERITY_SUCCESS,
                        creationDate: ''
                    });
                }
            } catch (error) {
                console.log(error);
                notify(pleaseRefreshError);
            }
        } else {
            notify({
                title: `${t('Please fill out the title.')}`,
                severity: NOTIFICATION_SEVERITY_INFO,
                creationDate: '',
            })
        }
    }

    // activate/disactivate handler for edition codes
	const editionCodeModerationHandler = async (editionCodeId, newstatus) => {
		try {
			const { data } = await axios.post(
				`${AUTHORIZED_URL_PREFIX}${UPDATE_EDITION_CODE_STATUS}`,
				{ editionCodeId, newstatus},
				AxiosConfig()
			);
			if (data.success === true) {
				notify({
					title: `${t('Edition Code Status Updated')}`,
					severity: NOTIFICATION_SEVERITY_SUCCESS,
					creationDate: ''
				});
				window.dispatchEvent(new Event('editionCodeAddedOrChanged'));
			} else {
				notify(pleaseRefreshError);
			}
		} catch (error) {
			console.log(error);
			notify(pleaseRefreshError);
		}
	};

	const handleClose = () => {
		setInfoNewEditionCode(!infoNewEditionCode);
	};

	return (
		<React.Fragment>
            <Row style={{display:'flex',alignItems:'baseline'}}>
				<div style={{ display: 'flex', flexWrap: 'wrap', justifyContent:'flex-start', alignItems:'center' }}>
					<Col style={{padding:'0 1rem 0 0', minWidth:'15rem', maxWidth:'17rem'}}> {/*md={3}*/}
						<Form.Group className="mb-3" controlId="newcode">
							<FloatingLabel controlId="floatingnewcode" label={t("Edition Code")}>
							<Form.Control
								required
								type="text"
								maxLength={50}
								placeholder={t("Enter code")}
								value={newEditionCode}
								onChange={(e) => {
									setNewEditionCode(e.target.value);
								}}
							/>
							</FloatingLabel>
						</Form.Group>
					</Col>
					<Col style={{padding:'0 1rem 0 0', minWidth:'15rem', maxWidth:'15rem'}}> {/*(md={4}*/}
						<Form.Group className="mb-3" controlId="startDate">
								<Form.Label style={{marginBottom:'0rem'}}>{t('Set Date')}</Form.Label>
								<DatePicker selected={editionCodeStartDate} onChange={(date) => setEditionCodeStartDate(date)} />
						</Form.Group>
					</Col>
					<Col style={{display:'flex', alignItems:'center' ,marginBottom:'1rem', padding:'0 1rem 0 0', minWidth:'15rem'}}> {/*{md={5}*/}
						<FaInfo style={{ cursor: 'pointer', marginRight:'0.5rem' }} onClick={() => setInfoNewEditionCode(!infoNewEditionCode)} />
						<LykioButton variant="contained" onClick={() => newEditionCodeUploadHandler()}>
							{t('Add Edition Code')}
						</LykioButton>
					</Col>
					{infoNewEditionCode && (
						<Modal show={true} onHide={handleClose}>
							<Modal.Header closeButton>
								<Modal.Title></Modal.Title>
							</Modal.Header>
							<Modal.Body>
								{t('By pressing this button a new edition code will be added. You have the option to select a past date as the starting date of this edition code. Every user that consumes content on the platform after this date will be assigned to this code if there is no date more recent.')}
							</Modal.Body>
							<Modal.Footer>
							</Modal.Footer>
						</Modal>
					)}
				</div>
            </Row>
  
			<Table striped bordered hover size="sm" {...getTableProps()}>
				<TableHead>
					{headerGroups.map((headerGroup) => (
						<TableRow {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => (
								<th {...column.getHeaderProps(column.getSortByToggleProps())}>
									{column.render('Header')}
									{column.isSorted ? column.isSortedDesc ? ' ↓' : ' ↑' : ''}
								</th>
							))}
						</TableRow>
					))}
				</TableHead>
				<TableBody {...getTableBodyProps()}>
					{page.map((row) => {
						prepareRow(row);
						return (
							<TableRow {...row.getRowProps()}>
								{row.cells.map((cell) => {
									return <TableCell {...cell.getCellProps()}>{cell.render('Cell')}</TableCell>;
								})}
							</TableRow>
						);
					})}
				</TableBody>
			</Table>


			{/*Pagination*/}
			
			{/*<div className="lykiocss-pagination lykiocss-stick-to-bottom">
				<LykioButton variant="contained" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
					{t('First')}
				</LykioButton>&nbsp;
				<LykioButton variant="contained" onClick={() => previousPage()} disabled={!canPreviousPage}>
					{t('Previous')}
				</LykioButton>&nbsp;
				<span className="lykiocss-pageNum">
					{' '}
					{t('Page')} {pageIndex + 1} / {pageOptions.length}{' '}
				</span>&nbsp;
				<span>
					{' '}
					| {t('Page')}{' '}
					<input
						className="lykiocss-pageSelector"
						type="number"
						value={pageIndex + 1}
						onChange={(e) => gotoPage(e.target.value ? Number(e.target.value) - 1 : 0)}
					/>{' '}
				</span>&nbsp;
				<LykioButton variant="contained" onClick={() => nextPage()} disabled={!canNextPage}>
					{t('Next')}
				</LykioButton>&nbsp;
				<LykioButton
					variant="contained"
					onClick={() => gotoPage(pageCount - 1)}
					disabled={!canNextPage}
				>
					{t('Last')}
				</LykioButton>&nbsp;
				<select
					className="lykiocss-items-count-selector"
					value={pageSize}
					onChange={(e) => setPageSize(Number(e.target.value))}
				>
					{[ 5, 10, 25, 50, 100 ].map((pageSize) => (
						<option key={pageSize} value={pageSize}>
							{' '}
							{pageSize}
						</option>
					))}
				</select>
			</div>*/}
		</React.Fragment>
	);
};

export default EditionCode;
